import React from "react";

const BarChartPage = ({ data = [] }) => {
  const chartData = data;
  const maxCount = Math.max(...chartData.map((d) => d.count));

  return (
    <div className="bar-chart-container">
      <h4 className="bar-chart-title">Application Status Chart</h4>

      {/* Legend */}
      <div className="bar-chart-legend">
        {chartData.map((item) => (
          <div key={item.label} className="legend-item">
            <div className="legend-color" style={{ backgroundColor: item.color }}></div>
            <span className="legend-label">{item.label}</span>
          </div>
        ))}
      </div>

      {/* Bars Container */}
      <div className="bar-chart-bars-container">
        {chartData.map((item) => (
          <div key={item.label} className="bar-chart-column">
            {/* Bar */}
            <div
              className="bar-chart-bar"
              style={{
                height: `${(item.count / maxCount) * 120}px`,
                backgroundColor: item.color,
              }}
            >
              {/* Count label on bar */}
              <div className="bar-tooltip">{item.count.toLocaleString()}</div>
            </div>

            {/* Count below bar */}
            <div className="bar-count">{item.count.toLocaleString()}</div>

            {/* Label below bar */}
            <div className="bar-label">
              {item.label
                .split(" ")
                .map((word, i, arr) => (i < 2 ? word : i === 2 && arr.length > 2 ? word + "..." : ""))
                .filter(Boolean)
                .join(" ")}
            </div>
          </div>
        ))}
      </div>

      {/* Summary */}
      <div className="bar-chart-summary">
        <div className="summary-text">Total Applications: {chartData.reduce((sum, item) => sum + item.count, 0).toLocaleString()}</div>
      </div>
    </div>
  );
};

export default BarChartPage;
